import React, { useState, useEffect } from "react";
import HeroBackground from "../../assets/images/IZB/IZB Website Skin/Home_Page/New_changes/Untitled-1.png";
import MobileStoreButton from "react-mobile-store-button";
import "./Hero.css";
import { FiCheckCircle } from "react-icons/fi";
import { Link } from "react-router-dom";

import BankingMenu from "./BankingMenu";

const HeroSlide3 = () => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleWindowResize = () => {
      setIsMobileView(window.innerWidth < 700); // Set the mobile view based on the window width
    };

    // Add event listener to handle window resize
    window.addEventListener("resize", handleWindowResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const bannerPhones =
    "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 1000003036.png";
  const fastserve =
    "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-fast-serve_png.png";
  const Logo = "https://izbassetsmain.blob.core.windows.net/izbwebassets/logo.png";

  // const HeroBgimg = {
  //   height: "75vh",
  //   backgroundRepeat: "no-repeat",
  //   backgroundSize: "100%",
  //   overflow: "hidden",
  // };

  return (
    <>
        <Link to="">
          {/* <div style={HeroBgimg} className="HeroSlider3">
            <div className="auto-container sliderContent h-100">
              <div className="h-75 position-relative ">
                <div className="d-flex justify-content-end align-items-center h-100">
                  <div className="flex-column flex-wrap align-self-xl-center text-center">
                    <h5 className="py-1 text-dark">
                     
                    </h5>
                    <div className="my-3 text-center">
                      
                    </div>
                    <h5 className="py-1 text-dark">
                    
                    </h5>
                    <h5 className="py-1 text-dark my-3">
                     
                      <span
                        style={{
                          color: "rgb(158, 27, 30)",
                          fontWeight: "800",
                        }}
                      >
                     
                      </span>
                      <br />
                      <span style={{ color: "rgb(158, 27, 30)" }}>
                      
                      </span>
                    </h5>
             
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_NXT_app.png" alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
          <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/NXT_App_Mobile_Banner_1.png" alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" />
        </Link>
    </>
  );
};

export default HeroSlide3;
